<template>
  <div v-if="pageComponent" :id="pageComponent.uuid" :ref="pageComponent.uuid" :data-type="pageComponent.properties.element_type" :class="customClasses" :style="mapCssProperties">
    <div id="inside" :style="insideDiv">
      <kiosk-elements v-for="element in pageComponent.parent_elements" :key="element.uuid"
      :element="element"
        :kioskProperties="kioskProperties"
        :sessionUuid="sessionUuid" />

      <kiosk-child-components v-for="component in pageComponent.children" :key="component.uuid"
      :component="component"
        :parentComponent="pageComponent"
        :kioskProperties="kioskProperties"
        :sessionUuid="sessionUuid" />
    </div>
  </div>
  <loading-overlay v-else />
</template>

<script>
import LoadingOverlay from '../services/loading-overlay.vue';
import HelperMethods from '../mixins/helper_methods';
import ComponentEventHelper from '../mixins/component_event_helper';
import KioskElements from '../elements/kiosk-elements.vue';
import OrderingHelper from '../mixins/ordering_helper';

export default {
  name: 'KioskScrollableArea',
  mixins: [HelperMethods, OrderingHelper, ComponentEventHelper],
  components: {
    LoadingOverlay,
    KioskElements,
    KioskChildComponents: () => import('./kiosk-child-components.vue'),
  },
  props: {
    pageComponent: Object,
    parentComponent: Object,
    kioskProperties: Object,
    sessionUuid: String,
  },
  data() {
    return {
      properties: this.pageComponent.properties,
    };
  },
  computed: {
    insideDiv() {
      const mappedCSSProperties = {};
      if (this.properties) {
        mappedCSSProperties.height = `${Math.ceil(this.properties.height + this.properties.offscreenHeight)}px`;
        mappedCSSProperties.width = `${Math.ceil(this.properties.width + this.properties.offscreenWidth)}px`;
      }
      return mappedCSSProperties;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
